import { z } from "@/zod";
import question from "./question";

const survey = z.object({
  id: z.string(),
  name: z.string().min(5).max(250),
  description: z.string().max(1000),
  archived: z.boolean().optional(),
  questions: z.array(question),
});

export const writeSurvey = survey.omit({
  id: true,
});

export const readSurvey = survey;
